<template>
  <div class="wrapper" v-loading="ifLoading">
    <!-- <div class="structureSide">
      <el-tree
        :data="departmentGroupTree"
        :props="propsSet"
        @node-click="treeClick"
      ></el-tree>
    </div> -->
    <div class="detailSide">
      <div class="tableBox">
        <div class="actBar">
          <div class="leftSide">
            <el-input
              placeholder="请输入角色名称"
              v-model="searchCondition.roleName"
              style="width: 300px"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getData"
              ></el-button> </el-input
            >&emsp;
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="showRoleDetail(true)"
              >新增角色</el-button
            >
          </div>
          <div class="rightSide">
            <!-- <el-button>手动排序</el-button>
            <el-button>按字母排序</el-button> -->
          </div>
        </div>
        <br />
        <el-table :data="dataList" border style="width: 100%">
          <el-table-column prop="roleName" label="角色名称" min-width="200">
          </el-table-column>
          <el-table-column
            prop="userCount"
            label="数量"
            min-width="60"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="roleDesc" label="职务描述" min-width="200">
          </el-table-column>
          <el-table-column
            prop="openFrontpage"
            label="首页可视"
            min-width="200"
          >
            <template slot-scope="scope">
              <el-switch
                style="display: block; line-height: 23px; height: 23px"
                v-model="scope.row.openFrontpage"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="可查看"
                inactive-text="不可查看"
                :active-value="1"
                :inactive-value="0"
                @change="(value) => switchMainpage(scope.row, value)"
              >
              </el-switch>
            </template>
          </el-table-column>

          <el-table-column prop="updateTime" label="更新时间" width="200">
          </el-table-column>

          <!-- <el-table-column prop="zip" label="最后登录" width="120">
          </el-table-column> -->
          <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="300"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="editUserByRole(scope.row)"
                >添加人员</el-button
              >
              <el-button
                type="text"
                size="small"
                @click="showRoleDetail(false, scope.row)"
                >编辑角色</el-button
              ><el-button
                type="text"
                size="small"
                @click="
                  $router.push({
                    name: 'roleEdit',
                    query: scope.row,
                  })
                "
                >设置权限</el-button
              >
              <!-- <el-button type="text" size="small" @click="editUser(scope.row)"
                >停用角色</el-button
              >
              <el-button type="text" size="small" @click="editUser(scope.row)"
                >复制角色</el-button
              > -->
              <el-button type="text" size="small" @click="deleteRole(scope.row)"
                >删除角色</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size.sync="searchCondition.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="searchCondition.total"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="ifCreate ? '添加用户' : '用户编辑'"
      :visible.sync="roleData.ifShow"
      append-to-body
      width="50%"
    >
      <el-form :model="roleData" class="demo-form-inline" label-width="120px">
        <el-form-item label="角色名称">
          <el-input
            v-model="roleData.roleName"
            placeholder="请输入角色名称"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            style="width: 300px"
            type="textarea"
            maxlength="150"
            v-model="roleData.roleDesc"
            placeholder="请输入角色描述"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="submitRoleDetail">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="编辑使用该角色的用户"
      :visible.sync="userInRoleData.ifShow"
      append-to-body
      width="50%"
    >
      <el-form :model="roleData" class="demo-form-inline" label-width="120px">
        <el-form-item label="角色名称">
          <el-input
            v-model="userInRoleData.roleName"
            placeholder="请输入角色名称"
            style="width: 300px"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="添加成员">
          <div class="tagBox">
            <el-tag
              :key="'user' + tag.id"
              v-for="tag in userInRoleData.users"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag.userName }}
            </el-tag>
            <el-autocomplete
              class="input-new-tag"
              size="small"
              v-model="userInRoleData.searchText"
              v-if="userInRoleData.inputVisible"
              :fetch-suggestions="userInputSearch"
              placeholder="请输入内容"
              ref="saveTagInput"
              @select="handleInputConfirm"
            >
              <template slot-scope="{ item }">
                <div class="name">{{ item.userName }}</div>
                <!-- <span class="addr">{{ item.address }}</span> -->
              </template></el-autocomplete
            >

            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >+ 添加用户</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="submitRoleBelong">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  searchCooperative,
  getUserByRole,
  getRoleListNew,
  createRole,
  updateRole,
  deleteRoles,
  getSystemUserList,
  setUsersRole,
} from "@/api/index";

export default {
  data() {
    return {
      ifLoading: false,
      ifCreate: true,
      departmentGroupTree: [],
      propsSet: {
        children: "children",
        label: "groupName",
      },
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        roleName: "",
      },
      roleData: {
        ifShow: false,
        id: "",
        roleName: "",
        roleDesc: "",
      },
      dataList: [],
      roleList: [],

      userInRoleData: {
        ifShow: false,
        users: [],
        roleId: 0,
        inputVisible: false,
        inputValue: "",
        searchText: "",
      },
      userList: [],
    };
  },
  created() {},
  mounted() {
    this.pageInit();
  },
  methods: {
    switchMainpage(item, value) {
      updateRole(item).then((data) => {
        this.$message.success("保存成功");
        this.getData();
      });
    },
    userInputSearch(queryString, cb) {
      var userList = this.userList;
      var usersIdExist = this.userInRoleData.users.map((item) => item.id);

      var results = userList.filter((obj) => !usersIdExist.includes(obj.id)) //排除已选
        ? userList.filter((obj) => {
            return (
              obj.userName.toLowerCase().indexOf(queryString) > -1 &&
              !usersIdExist.includes(obj.id) //排除已选后和关键字匹配
            );
          })
        : userList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleClose(tag) {
      this.userInRoleData.users.splice(
        this.userInRoleData.users.indexOf(tag),
        1
      );
    },
    editUserByRole(role) {
      this.ifLoading = true;
      getUserByRole({ roleId: role.id }).then((data) => {
        this.userInRoleData.users = data;
        Object.assign(this.userInRoleData, role);
        this.userInRoleData.ifShow = true;
        this.userInRoleData.inputVisible = false;
        this.ifLoading = false;
      });
    },
    submitRoleBelong() {
      this.userInRoleData.userIds = this.userInRoleData.users.map(
        (item) => item.id
      );
      setUsersRole({
        roleId: this.userInRoleData.id,
        userIds: this.userInRoleData.userIds,
      }).then((data) => {
        this.$message.success(data);
        this.userInRoleData.ifShow = false;
        this.getData();
      });
    },
    pageInit() {
      this.getData();
      getSystemUserList({
        pageNumber: 1,
        pageSize: 1000,
        departmentId: 0,
      }).then((data) => {
        this.userList = data.rows;
      });
    },
    showInput() {
      this.userInRoleData.searchText = "";
      this.userInRoleData.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm(value) {
      if (value) {
        this.userInRoleData.users.push(value);
      }
      this.userInRoleData.inputVisible = false;
      this.userInRoleData.searchText = "";
    },
    treeClick() {},
    getData() {
      getRoleListNew(this.searchCondition).then((data) => {
        this.dataList = data.rows;
        this.searchCondition.total = data.total;
      });
    },
    editUser(item) {
      Object.assign(this.roleData, item);
      this.roleData.ifShow = true;
    },
    showRoleDetail(ifCreate, item = null) {
      this.ifCreate = ifCreate;
      if (ifCreate) {
        Object.assign(this.roleData, this.$options.data().roleData);
      } else {
        Object.assign(this.roleData, item);
      }
      this.roleData.ifShow = true;
    },
    submitRoleDetail() {
      if (this.ifCreate) {
        createRole(this.roleData).then((data) => {
          this.$message.success("新增成功");
          this.roleData.ifShow = false;
          this.getData();
        });
      } else {
        updateRole(this.roleData).then((data) => {
          this.$message.success("保存成功");
          this.roleData.ifShow = false;
          this.getData();
        });
      }
    },
    deleteRole(item) {
      this.$confirm(`确认删除吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((data) => {
        deleteRoles({ roleIds: [item.id] }).then((data) => {
          this.$message.success("删除成功");
          this.getData();
        });
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  //   display: flex;
  min-height: 600px;
  .structureSide {
    flex: 1;
    min-width: 200px;
    margin-right: 10px;
    background: #fff;
  }
  .detailSide {
    flex: 5;
    background: #fff;
    padding: 20px;
  }
  .tableBox {
    .actBar {
      display: flex;
      justify-content: space-between;
    }
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
